var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("v-file-input", {
        ref: "fileSelector",
        attrs: {
          dense: "",
          type: "file",
          accept: "video/*",
          showSize: false,
          placeholder: _vm.inputPlaceholder
        },
        on: { "click:clear": _vm.onFileSelectorClear },
        model: {
          value: _vm.file,
          callback: function($$v) {
            _vm.file = $$v
          },
          expression: "file"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "v-label v-label--active theme--dark" }, [
        _vm._v("\n    " + _vm._s(_vm.lblShowStatus) + "\n  ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }